import React, {useState, useEffect, useRef, useContext} from "react";
import BasicView from "../../components/BasicView";
import {SecondView, TitleSection, TitleViewCard} from "../../styles/HeadView";
//import {TypeTitle} from "../../styles/Products";
import {Content} from "../../styles/GlobalStyles";
//import Color from "../../assets/Colors";
import Offer from "../../styles/Offer";
import HeadsVies from "../../styles/HeadsVies";
import DownArrow from "../../components/DownArrow";
import scrollToRef from "../../constants/DownAction";
import {CoursesContext} from "../../context/CoursesContext";
import {LoadComponet} from "../../components/loaders/Loader";
import {HeadersContext} from "../../context/HeadersContext";
import useSetTitle from "../../hooks/useSetTitle";

export default function EssentialCousers() {
   useSetTitle("Cursos esenciales");
   const {getEssential, essential} = useContext(CoursesContext);
   const {getHeader, essentialHeader} = useContext(HeadersContext);
   const [isMobile, setMobile] = useState(false);

   useEffect(() => {
      getEssential();
      getHeader("Essentials");
      setMobile(window.screen.width <= 500);
   }, []);

   const CursosEsencialesRef = useRef(null);
   const goTo = () => scrollToRef(CursosEsencialesRef);

   if (essentialHeader.isLoading) return <LoadComponet isVisible={true} />;

   return (
      <BasicView
         imageBack={`http://domecqapi.trebolbit.com/${isMobile ? essentialHeader.pathImageWebMobile : essentialHeader.pathImageWebDesktop}`}
      >
         <HeadsVies
            type={1}
            title={
               isMobile ? (
                  "Cursos esenciales Domecq"
               ) : (
                  <span>
                     Cursos <br /> esenciales Domecq
                  </span>
               )
            }
            description={essentialHeader.description}
         />

         <SecondView>
            <DownArrow goTo={goTo} />
            <Content ref={CursosEsencialesRef}>
               <TitleSection>
                  <img src={require("../../assets/icons/essential_offer.png")} alt="offer" className="icon grand" />
                  <TitleViewCard>Oferta académica</TitleViewCard>
               </TitleSection>
            </Content>
            {essential.isLoading ? (
               <LoadComponet isVisible={true} />
            ) : (
               <Content>
                  <Offer data={essential.offer} pathName="cursos_esenciales" />
               </Content>
            )}
         </SecondView>
      </BasicView>
   );
}
